import { Button } from "@kompare/kompare-ui-library";
import { i18n, showMessage, useGetFileById, useGetTermsAndConditionsFromFiles, useSendTermsAndConditionsToEmail } from "src/common";
import { isRateLimitDenial } from "src/common/apiGraphql/captcha";
import TermsCard from "../cards/termsCard";
import { Loader } from "../other";
import { Flex } from "../grid";
import { useState } from "react";
import BaseModal from "./base.modal";


export interface TermsAndConditionsProps {
  open?: boolean;
  title?: string;
  onClose?: () => void;
}

export const TermsAndConditionsModal = ({ open = false, title = i18n.t('components.modals.termsAndConditionsModal.title'), onClose }: TermsAndConditionsProps) => {
  const { termsAndConditions, loading: termsAndConditionsLoading } = useGetTermsAndConditionsFromFiles();
  const { loading: downloadFileLoading } = useGetFileById();
  const [sendTermsAndConditionsToEmail] = useSendTermsAndConditionsToEmail();
  const [ loading, setLoading ] = useState<boolean>(false);
  return (
    <BaseModal title={title} maxWidth={620} open={open} onClose={() => onClose && onClose()}>
      <Flex vertical gap={12}>
        <TermsCard termsAndConditions={termsAndConditions} isModal={true} />
        <Button type="button" btnType="outlinePrimary" text={i18n.t('components.modals.termsAndConditionsModal.sendToEmail')} onClick={() => {
          setLoading(true);
          sendTermsAndConditionsToEmail().then(() => {
            setLoading(false);
            onClose && onClose();
            showMessage({ message: i18n.t('common.messages.termsAndConditionsSentToEmail'), type: 'success', duration: 5000, fixed: true });
          })
          .catch((error) => {
            // RATE_LIMITED / IP_BLOCKED are already toasted by the Apollo error link.
            if (isRateLimitDenial(error)) return;
            showMessage({
              type: 'error',
              message: i18n.t('common.messages.error'),
              duration: 5000,
              fixed: true
            });
          })
          .finally(() => {
            setLoading(false);
          });
        }} />
      </Flex>
      {(downloadFileLoading || termsAndConditionsLoading || loading) && <Loader overlay={true} />}
    </BaseModal>
  );
};

